:host {
  --chip-margin-left: calc(var(--spacer) * 2);
}

gz-tooltip {
  margin-left: var(--chip-margin-left);
}
gz-chip {
  --content-max-width: fit-content;
}
